import { uuidv4 } from '../../settings/shared/commonMethods';

const { AnsiUp } = require('ansi_up');
const ansi_up = new AnsiUp();

var Convert = require('ansi-to-html');

function convertStream(text) {
    var _text = text.split("\n")
    for (let i = 0; i < _text.length; i++) {
        var _r_split = _text[i].split("\r")
        var _last_r = _r_split[_r_split.length - 1]
        if (_last_r !== undefined && _last_r !== null && _last_r !== "") {
            _text[i] = _last_r
        } else {
            _text[i] = _r_split[_r_split.length - 2]
        }
    }
    return _text.join("\n");
}

/**
 * Render array of cell outputs
 * 
 * @param {Array} outputData 
 */
function renderOutput(outputData) {
    var divObj = document.createElement('div');
    divObj.setAttribute("id", uuidv4())
    if ((outputData !== undefined) && (Array.isArray(outputData))) {
        outputData.forEach(element => {
            divObj.appendChild(renderDisplayData(element))
        });
    }
    return divObj.innerHTML;
}

/**
 * 
 * @param {Array} data - Output data render
 */
function renderDisplayData(data) {
    var divObj = document.createElement('div');
    divObj.setAttribute("className", 'displaytxt framediv col-12')
    divObj.setAttribute("id", uuidv4())
    var convert = new Convert();
    if (data !== undefined) {
        var output_type = data.output_type
        if (output_type !== undefined) {
            if (output_type === 'display_data') {
                var imageBase64 = data.data['image/png'];
                var dataTableHtmlDisplay = data.data['text/html']
                if (imageBase64 !== undefined) {
                    divObj.innerHTML += '<img src="data:image/png;base64,' + imageBase64 + '"/>'
                }
            }
            if (output_type === 'execute_result') {
                var dataTablePlain = data.data['text/plain']
                var dataTableHtmlExecute = data.data['text/html']
                if (dataTablePlain !== undefined && dataTableHtmlExecute === undefined) {
                    dataTablePlain.forEach(element => {
                        divObj.innerHTML += ansi_up.ansi_to_html(element)
                    });
                }
            }
            if (output_type === 'error') {
                var traceback = data.traceback;
                if (traceback !== undefined) {
                    traceback.forEach(element => {
                        divObj.innerHTML += convert.toHtml(element);
                        divObj.innerHTML += "\n"
                    });
                }
            }

            if (output_type === 'stream') {
                var stream_type = data.name;
                var streamDivObj = document.createElement('div');
                streamDivObj.setAttribute("id", uuidv4())

                if (stream_type === 'stdout') {
                    divObj.setAttribute("className", 'displaytxt')
                } else if (stream_type === 'stderr') {
                    divObj.setAttribute("className", 'displaytxt') //TODO: Set Font color to Red
                }
                var data_text = data.text;
                if (Array.isArray(data_text)) {
                    data_text.forEach(element => {
                        streamDivObj.innerHTML += ansi_up.ansi_to_html(element)
                    });
                } else {
                    let ccc = convertStream(data_text);
                    streamDivObj.innerHTML += ansi_up.ansi_to_html(ccc);
                }

                divObj.appendChild(streamDivObj)
            }

        }
        var data_html = data.data;
        if (data_html !== undefined) {
            var dataTableHtmlFinal = data_html['text/html']
            if (dataTableHtmlFinal !== undefined) {
                divObj.innerHTML += convert.toHtml(dataTableHtmlFinal);
            }
        }
    }
    return divObj;
}

export { uuidv4, renderDisplayData, renderOutput };